// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyA6oLm7EHHx7JK32pXeQP5O2oepjMBtIEA",
  authDomain: "school-link-bb0e9.firebaseapp.com",
  databaseURL: "https://school-link-bb0e9-default-rtdb.firebaseio.com",
  projectId: "school-link-bb0e9",
  storageBucket: "school-link-bb0e9.appspot.com",
  messagingSenderId: "154769077784",
  appId: "1:154769077784:web:545841844a217adb5c356d",
  measurementId: "G-4LPPLWK1Y1"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
